import React from 'react';
export const Outlet = () => (
  <svg width="129px" height="68px" viewBox="0 0 129 68" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1073.000000, -1726.000000)">
        <g transform="translate(1073.000000, 1726.000000)">
          <path
            d="M107.8033,63.8451 L128.1753,63.8451"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M48.4932,63.8451 L0.6512,63.8451"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M83.1133,65.9018 C83.1133,66.9068 80.1273,67.7218 76.4443,67.7218 C72.7613,67.7218 69.7763,66.9068 69.7763,65.9018 C69.7763,64.8958 72.7613,64.0818 76.4443,64.0818 C80.1273,64.0818 83.1133,64.8958 83.1133,65.9018"
            fill="#D0D7DA"
          />
          <g transform="translate(45.000000, 15.710000)">
            <polyline
              fill="#FFFFFF"
              points="0.045 3.3119 0.045 0.0029 27.044 0.0029 27.044 24.2579 0.045 24.2579 0.045 6.7829"
            />
            <polyline
              stroke="#7350A0"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="0.045 3.3119 0.045 0.0029 27.044 0.0029 27.044 24.2579 0.045 24.2579 0.045 6.7829"
            />
          </g>
          <path
            d="M64.9957,33.4496 L52.0937,33.4496 C52.0937,33.4496 50.4227,30.9876 50.4227,28.3366 C50.4227,25.6846 52.0937,22.4846 52.0937,22.4846 L64.9957,22.4846 C64.9957,22.4846 66.6657,25.4536 66.6657,28.3366 C66.6657,31.2196 64.9957,33.4496 64.9957,33.4496 Z"
            stroke="#AA81F7"
          />
          <path
            d="M55.5499,26.0268 L55.5499,27.7038"
            stroke="#AA81F7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M61.7266,26.0268 L61.7266,27.7038"
            stroke="#AA81F7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M59.8423,30.9955 C59.8423,30.9955 59.9203,29.8585 58.6753,29.8585 C57.4293,29.8585 57.5073,30.9955 57.5073,30.9955 L59.8423,30.9955 Z"
            fill="#AA81F7"
          />
          <path
            d="M71.0089,9.7504 L71.0089,5.9044"
            stroke="#F5C400"
            strokeLinecap="round"
          />
          <path
            d="M76.7711,14.8559 L80.6161,14.8559"
            stroke="#F5C400"
            strokeLinecap="round"
          />
          <path
            d="M75.3477,11.1381 L78.1947,8.3621"
            stroke="#F5C400"
            strokeLinecap="round"
          />
          <path
            d="M125.3154,36.0951 C125.3154,36.0951 113.0214,37.9871 106.4714,50.5381 C98.6444,65.5361 83.9394,60.8731 83.9394,60.8731"
            stroke="#042F43"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M70.7774,63.9506 L74.4884,50.9306 C78.1654,51.9786 83.5914,53.5256 81.7354,60.0356 C79.8804,66.5456 74.4534,64.9986 70.7774,63.9506"
            fill="#FFFFFF"
          />
          <path
            d="M70.7774,63.9506 L74.4884,50.9306 C78.1654,51.9786 83.5914,53.5256 81.7354,60.0356 C79.8804,66.5456 74.4534,64.9986 70.7774,63.9506 Z"
            stroke="#0B9CE5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M73.5923,54.0766 L69.6053,52.9396"
            stroke="#0B9CE5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M71.7779,60.4408 L67.7909,59.3038"
            stroke="#0B9CE5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polyline
            stroke="#0B9CE5"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="82.0982 57.2026 84.4292 57.8666 82.9832 62.9376 80.7642 62.3056"
          />
          <path
            d="M75.4341,52.518 L80.2511,60.335 C80.2511,60.335 81.2051,57.29 79.9991,55.194 C78.7921,53.097 75.4341,52.518 75.4341,52.518"
            fill="#F3F4F6"
          />
          <g transform="translate(88.000000, 0.710000)">
            <path d="M0.4835,0.5179 L18.7725,0.5179" fill="#FFFFFF" />
            <path
              d="M0.4835,0.5179 L18.7725,0.5179"
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(88.000000, 9.710000)">
            <path d="M0.4835,0.3969 L28.5545,0.3969" fill="#FFFFFF" />
            <path
              d="M0.4835,0.3969 L28.5545,0.3969"
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(102.000000, 19.710000)">
            <path d="M0.0523,0.6088 L25.1233,0.6088" fill="#FFFFFF" />
            <path
              d="M0.0523,0.6088 L25.1233,0.6088"
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M98.7628,1.2279 L98.7628,10.1069"
            stroke="#DCE4E7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M113.5459,10.1069 L113.5459,20.3189"
            stroke="#DCE4E7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g transform="translate(5.000000, 32.710000)">
            <path d="M0.9151,0.1547 L12.2041,0.1547" fill="#FFFFFF" />
            <path
              d="M0.9151,0.1547 L12.2041,0.1547"
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(5.000000, 41.710000)">
            <path d="M0.9151,0.0336 L24.9861,0.0336" fill="#FFFFFF" />
            <path
              d="M0.9151,0.0336 L24.9861,0.0336"
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(12.000000, 51.710000)">
            <path d="M0.4839,0.2455 L17.5549,0.2455" fill="#FFFFFF" />
            <path
              d="M0.4839,0.2455 L17.5549,0.2455"
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M9.1944,32.8647 L9.1944,41.7437"
            stroke="#DCE4E7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M23.9776,41.7436 L23.9776,51.9556"
            stroke="#DCE4E7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polyline
            stroke="#E2E8EE"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="64.4512 38.1713 70.0882 38.1713 70.0882 34.0953"
          />
        </g>
      </g>
    </g>
  </svg>
);
